/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class HirePermissionsProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get role permissions from Hire
   * @param roleUuid
   * @returns any Hire role permissions
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesPermissionsHireRoles(
    roleUuid: string,
  ): CancelablePromise<{
    data?: Array<{
      application: 'hire' | 'hire_go';
      category: string;
      key: string;
      enabled: boolean;
      name: string;
      /**
       * Optional tooltip for the permission
       */
      tooltip?: string;
    }>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/permissions/hire/roles/{roleUuid}',
      path: {
        'roleUuid': roleUuid,
      },
    });
  }

  /**
   * Update role permissions on Hire
   * @param roleUuid
   * @param requestBody
   * @returns any Permissions updated successfully
   * @throws ApiError
   */
  public putApiServiceorganizationsProcessesPermissionsHireRoles(
    roleUuid: string,
    requestBody?: {
      /**
       * Object mapping permission keys to boolean values (enabled/disabled)
       */
      permissions: Record<string, boolean>;
    },
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/serviceorganizations/processes/permissions/hire/roles/{roleUuid}',
      path: {
        'roleUuid': roleUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
